import {
  BtnBold,
  BtnBulletList,
  BtnClearFormatting,
  BtnItalic,
  BtnNumberedList,
  BtnRedo,
  BtnStrikeThrough,
  BtnUnderline,
  BtnUndo,
  Editor,
  EditorProvider,
  Separator,
  Toolbar,
} from "react-simple-wysiwyg";
import s from "./TextEditor.module.css";

type TextEditorProps = {
  value: string;
  onChange: (value: string) => void;
  maxLength?: number;
};

const TextEditor = ({ value, onChange, maxLength }: TextEditorProps) => {
  const getPlainTextLength = (html: string) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent?.length ?? 0;
  };

  return (
    <div className={s.container}>
      <EditorProvider>
        <Editor
          value={value}
          onChange={(e) => {
            const html = e.target.value;
            const textLength = getPlainTextLength(html);
            if (maxLength && textLength > maxLength) return;
            if (html.includes("<img src=")) return;
            onChange(html);
          }}
          containerProps={{
            style: {
              resize: "vertical",
              borderRadius: "20px",
            },
          }}
        >
          <Toolbar
            style={{
              backgroundColor: "var(--card-bg)",
              borderBottom: "1px solid var(--border)",
              display: "flex",
              justifyContent: "space-between",
              padding: "5px 10px",
            }}
          >
            <div className={s.toolsBlock}>
              {window.innerWidth > 768 && (
                <>
                  <BtnUndo />
                  <BtnRedo />
                  <Separator />
                </>
              )}
              <BtnBold />
              <BtnItalic />
              <BtnUnderline />
              <BtnStrikeThrough />
              <Separator />
              <BtnNumberedList />
              <BtnBulletList />
              <BtnClearFormatting />
              <Separator />
              {/*  <BtnStyles /> */}
            </div>
            {maxLength && (
              <span className={s.charactersLimit}>
                {getPlainTextLength(value)} / {maxLength} characters
              </span>
            )}
          </Toolbar>
        </Editor>
      </EditorProvider>
    </div>
  );
};

export default TextEditor;
